<template>
    <v-row class="light--text" v-show="selectedMenu === 1">
        <v-col cols="12" xs12 class="ma-0 py-1 px-4">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="workDaysBit"
                    inset
                    label="Учитывать выбранные дни" color="primary"
                    :false-value="0"
                    :true-value="1"
            ></v-switch>
        </v-col>
        <v-col cols="1" class="ml-3 pa-0">Пн</v-col>
        <v-col cols="1" class="ma-0 pa-0">Вт</v-col>
        <v-col cols="1" class="ma-0 pa-0">Ср</v-col>
        <v-col cols="1" class="ma-0 pa-0">Чт</v-col>
        <v-col cols="1" class="ma-0 pa-0">Пт</v-col>
        <v-col cols="1" class="ma-0 pa-0">Сб</v-col>
        <v-col cols="1" class="ma-0 pa-0">Вс</v-col>
        <v-col cols="4" class="ma-0 pa-0">Все дни</v-col>
        <v-col cols="1" class="ma-0 pa-0"
               v-for="(value, index) in selectedDays"
               :key="index" :class="index === 0 ? 'ml-2' : ''"
        >
            <v-checkbox v-model="selectedDays[index]" :false-value="0"
                        :true-value="1" :value="selectedDays[index]"></v-checkbox>
        </v-col>

        <v-col cols="1" class="ma-0 pa-0">
            <v-checkbox v-model="checkAllDays" @input="checkAllDays = !checkAllDays"></v-checkbox>
        </v-col>
        <v-col cols="12" xs12 class="ma-0 py-1 px-4">
            <v-switch
                    class="ma-0 pa-0"
                    v-model="workTimeBit"
                    inset
                    label="Учитывать выбранне время" color="primary"
                    :false-value="0"
                    :true-value="1"
            ></v-switch>
        </v-col>
        <v-col cols="5" md6 class="ma-0 pa-0">
            <v-text-field
                    v-model="time1"
                    prepend-icon="access_time"
                    label="Время начала работы"
                    :value="time1"
                    @input="changeTime"
                    type="time"
            ></v-text-field>
        </v-col>
        <v-col cols="5" md6 offset-md-2 class="ma-0 pa-0">
            <v-text-field
                    v-model="time2"
                    prepend-icon="access_time"
                    label="Время окончания работы"
                    :value="time2"
                    @input="changeTime"
                    type="time"
            ></v-text-field>
        </v-col>
    </v-row>
</template>

<script>
import botConstants from './botConstants'
export default {
    name: 'BotFormWorkSchedule',
    data() {
        return {
            selectedDays: [1, 1, 0, 1, 1, 1, 1],
            checkAllDays: false,
            time1: null,
            time2: null
        }
    },
    props: ['botModel', 'selectedMenu'],
    methods: {
        changeTime() {
            if (this.time1 != null && this.time2 != null) {
                this.botModel.work_time = JSON.stringify([this.time1, this.time2])
            } else {
                this.botModel.work_time = null
            }
        },
        resolveTime() { // при выборе настроек времени всегда запускается эта функция
            let items = this.botModel.work_days.toString(2).split('').map(Number)
            let addDays = 7 - items.length
            for (let i = 0; i < addDays; i++) {
                items.unshift(0)
            }
            this.selectedDays = items
            if (this.botModel.work_time != null) {
                this.time1 = JSON.parse(this.botModel.work_time)[0]
                this.time2 = JSON.parse(this.botModel.work_time)[1]
            }
        },
        setBit(bitNumber, value) {
            return value ? this.botModel.setting_public | (1 << bitNumber) : this.botModel.setting_public & (~(1 << bitNumber))
        }
    },
    computed: {
        workDays() {
            let result = ''
            for (let i = 0; i < this.selectedDays.length; i++) {
                result += this.selectedDays[i]
            }
            return parseInt(result, 2)
        },
        workDaysBit: {
            get() {
                return this.botModel.setting_public & (1 << botConstants.settingPublicWorkDays) >= 1 ? 1 : 0
            },
            set(value) {
                this.botModel.setting_public = this.setBit(botConstants.settingPublicWorkDays, value)
            }
        },
        workTimeBit: {
            get() {
                return this.botModel.setting_public & (1 << botConstants.settingPublicWorkTime) ? 1 : 0
            },
            set(value) {
                this.botModel.setting_public = this.setBit(botConstants.settingPublicWorkTime, value)
            }
        }
    },
    watch: {
        selectedDays () {
            let result = ''
            for (let i = 0; i < this.selectedDays.length; i++) {
                result += this.selectedDays[i]
            }
            this.botModel.work_days = parseInt(result, 2)
        },
        checkAllDays() {
            this.selectedDays = this.checkAllDays ? [1, 1, 1, 1, 1, 1, 1] : [0, 0, 0, 0, 0, 0, 0]
        },
        selectedMenu(value) {
            if (value === 1) { this.resolveTime() }
        }
    }
}
</script>

<style scoped>

</style>
